var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-container',[_c('b-row',[_c('b-col',[_c('b-card',{attrs:{"title":"Tenancy Tests"}},[_c('b-card-text',[_c('p',[_vm._v("Test your tenancy here")])])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }